'use strict';

const { __ } = wp.i18n;

/**
 * Init All Controls Logic
 */
class TWER_CONTROLS {

  /**
   * Controls constructor
   *
   * @param props
   */
  constructor(props) {
    // Init JQuery
    this.$ = $ = props;


    // Toggle TR table row after controls change
    const toggleElements = document.querySelectorAll('.js-twer-tr-toggle');
    const toggleControls = [];

    // Load status show/hide
    toggleElements.forEach(element => {
      const $toggleControl = document.getElementById(element.getAttribute('id').replace('-toggle',''));
      toggleControls.push($toggleControl);

      const toggleControlValue = $toggleControl.options[$toggleControl.selectedIndex].value;
      const triggerValue = element.dataset.trigger;
      if(toggleControlValue === triggerValue) {
        element.classList.add('twer-tr-toggle--show');
        element.classList.remove('twer-tr-toggle--hide');
      } else {
        element.classList.remove('twer-tr-toggle--show');
        element.classList.add('twer-tr-toggle--hide');
      }
    });

    // Change status
    toggleControls.forEach(element => {
      element.addEventListener('change', event => {
        const $toggleElement = document.getElementById(event.target.getAttribute('id') + '-toggle');

        const toggleControlValue = event.target.value;
        const triggerValue = $toggleElement.dataset.trigger;

        if(toggleControlValue === triggerValue) {
          $toggleElement.classList.add('twer-tr-toggle--show');
          $toggleElement.classList.remove('twer-tr-toggle--hide');
        } else {
          $toggleElement.classList.remove('twer-tr-toggle--show');
          $toggleElement.classList.add('twer-tr-toggle--hide');
        }
      });
    });

  }

}

export default TWER_CONTROLS;

